// export const logout = ( state ) => {
// }

export const setInputs = (state, inputs) => {
    state.inputs = inputs
}

export const setInputsSelectable = (state, inputs) => {
    state.inputsSelectable = inputs
}

export const setInputSelect = ( state, input ) => {
    state.inputSelect = input
}


export const setInputsPaginated = (state, inputsPaginatedData) => {
    state.inputsPaginatedData = inputsPaginatedData
}

export const setInputDetail = (state, input) => {
    state.input = input
}

export const saveNewInputs = (state, input) => {
    state.inputs.unshift(input)
    state.createdData = input;
}

export const saveUpdatedInput = (state, input) => {
    state.inputs.unshift(input)
    state.updatedData = input;
}

export const setDeleteInput = (state, input) => {
    state.inputsPaginatedData.data.filter(x => x.id !== input.id);
    state.deletedData = input
}

export const setInputIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setInputIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setInputIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setInputIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setInputIsCancelating = (state, isCancelating) => {
    state.isCancelating = isCancelating
}

export const setCancelInput = (state, input) => {
    state.cancelatedData = input;
}